// extracted by mini-css-extract-plugin
export default {"img":"ArticleImage_img__fzf84","imgWide":"ArticleImage_imgWide__jSjsH"};